export const SET_INSTAGRAM = "SET_INSTAGRAM";
